export default __webpack_public_path__ + "1efaf51218a0a06b83613b50952747f7.png";